import ENV from "config/Env";
import { backendQueryKey, permanentBackendQueryKey } from "hooks/useTypedQuery";

import type { DealerID, Question, QuestionElement, QuestionID, Tag } from "models";

const component = "QuestionsDashboard";

export const QuestionsDashboardQueryKeys = {
  dealerQuestions: (id?: DealerID) => backendQueryKey<Question[]>({ component, baseUrl: ENV.dealerBaseURL, endpoint: "/questions/search", params: { id } }),
  defaultQuestions: backendQueryKey<Question[]>({ component, baseUrl: ENV.dealerBaseURL, endpoint: "/questions/default" }),
  questionDetails: (id?: QuestionID) => backendQueryKey<Question>({ component, baseUrl: ENV.dealerBaseURL, endpoint: "/questions/view", params: { id } }),
  questionElements: permanentBackendQueryKey<QuestionElement[]>({ component, baseUrl: ENV.dealerBaseURL, endpoint: "/question_elements/list" }),
  tags: permanentBackendQueryKey<Tag[]>({ component, baseUrl: ENV.systemBaseURL, endpoint: "/tags/list" })
};
